import { OrganizationList } from "@clerk/react";
import { HeroImage } from "@/components/auth/hero-image";
import { Breadcrumbs, Link, Stack, Typography } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ClerkWrapper } from "@/components/auth/clerk-wrapper";
import { OnboardingPage } from "@/components/auth/onboarding-page";

export const Route = createFileRoute("/_auth/onboarding/organization")({
  component: RouteComponent,
  beforeLoad: async ({ context, search }) => {
    if (!context.auth.isSignedIn) {
      throw redirect({ to: "/signin" });
    }
    if (context.auth.orgId) {
      throw redirect({ to: "/onboarding/about-you", search });
    }
  },
});

function RouteComponent() {
  const { redirect_url: redirectUrl } = Route.useSearch();
  return (
    <OnboardingPage
      page={
        <Stack spacing={2}>
          <Breadcrumbs separator=">">
            <Link>About you</Link>
            <Typography>Invoices</Typography>
            <Typography>Email</Typography>
          </Breadcrumbs>
          <ClerkWrapper>
            <OrganizationList
              hidePersonal={true}
              skipInvitationScreen={true}
              afterCreateOrganizationUrl="/onboarding/about-you"
              afterSelectOrganizationUrl={redirectUrl}
              appearance={{
                options: { logoPlacement: "none" },
                variables: { fontSize: { md: "0.875rem" } },
              }}
            />
          </ClerkWrapper>
        </Stack>
      }
      hero={
        <HeroImage
          copy="Great support there when you need it"
          url="/assets/onboarding-2.svg"
          imageMaxWidth="700px"
          imageMarginTop={6}
        />
      }
    />
  );
}
